import { render } from "./reviewModal.vue?vue&type=template&id=1b65bac3&scoped=true"
import script from "./reviewModal.vue?vue&type=script&lang=js"
export * from "./reviewModal.vue?vue&type=script&lang=js"

import "./reviewModal.vue?vue&type=style&index=0&id=1b65bac3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b65bac3"]])

export default __exports__